import React, { useState } from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme, Fade } from '@mui/material';

const circlesData = [
  {
    label: 'CONFORT',
    description: (<span>Garantizar un futuro estable y armonioso para ti y tu familia, comenzando con un hogar seguro y acogedor. Fomentar un entorno de bienestar integral mediante una alimentación saludable y la creación de espacios donde cada miembro pueda desarrollarse plenamente.<br></br><br></br>
      Este objetivo incluye proteger tu tranquilidad y privacidad, preparándote para afrontar cualquier incertidumbre con confianza.</span>),
    image: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745869014/ebm/propiedad-confort_fvetwf.png',
  },
  {
    label: 'PROGRESO',
    description: (
      <span>
        Facilitar tu crecimiento personal y contribuir al desarrollo de tu comunidad, impactando positivamente en la vida de los demás.
        <br></br>
        Este objetivo busca fomentar la innovación, apoyar ideas transformadoras y promover mejoras sociales y económicas que beneficien tanto a las generaciones actuales como futuras.
      </span>
    ),
    image: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745869023/ebm/propiedad-progreso_zrimt2.png',
  },
  {
    label: 'LIBERTAD',
    description: (
      <span>
        Alcanzar la independencia financiera que te permita vivir con plenitud, autenticidad y en armonía con tus valores.
        <br></br>
        Este objetivo busca invertir en activos estratégicos, fomentar el crecimiento personal y profesional a través del aprendizaje continuo y habilitarte para perseguir tus pasiones sin ataduras ni las limitaciones de las expectativas externas.
      </span>
    ),
    image: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745869006/ebm/propiedad-libertad_wkk0iw.png',
  },
  {
    label: 'SEGURIDAD',
    description: (
      <span>
        Proteger y mantener la estabilidad financiera a largo plazo, asegurando que tu estilo de vida no esté en riesgo. Diversificar tus ingresos y estar preparado para imprevistos, garantizará tu bienestar y el de tus seres queridos.
        <br></br>
        Este objetivo también incluye construir un sistema de seguridad social sólido que permita disfrutar de una vida plena y sin sobresaltos.
      </span>
    ),
    image: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745868995/ebm/propiedad-seguridad_s2bdtl.png',
  },
  {
    label: 'LEGADO',
    description: (
      <span>
        Construir un legado significativo que inspire y transforme a las generaciones futuras.
        <br></br>
        Este objetivo busca preservar los valores y recursos que benefician a la sociedad, fomentando la innovación y dejando una huella positiva en el mundo.
        <br></br>
        Cada decisión que tomas hoy es una oportunidad para crear un impacto duradero.
      </span>
    ),
    image: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745869032/ebm/propiedad-legado_nbz84e.png',
  },
];

export default function PurposeCirclesSection() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleMouseEnter = (index) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    const id = setTimeout(() => {
      setHoveredIndex(null);
    }, 2000);
    setTimeoutId(id);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'auto',
        width: 'auto',
        py: 4,
        mx: 2
      }}
    >
      <Grid container justifyContent="center" sx={{
        maxWidth: '1345px',
        height: { xs: 'auto', lg: '451px' }, 
        backgroundImage: { xs: 'none', lg: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745859790/ebm/fondo-proposito_epov0c.png)' },
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        alignItems: 'center',
        px: 2,
        gap: { xs: 2, lg: 0 }
      }}>
        {circlesData.map((circle, index) => (
          <Grid item xs={10} sm={3} md={2} lg={2.4} key={index} sx={{
            display: 'flex',
            flexDirection: { xs: 'column' },
            justifyContent: 'center',
            [theme.breakpoints.up('lg')]: {
              ...(index === 0 && { mt: 6, mr: 3, ml: -2 }), // Primer círculo más abajo
              ...(index === 1 && { mt: -6, mr: 3, ml: -5.5 }), // Segundo círculo hacia la izquierda y arriba
              ...(index === 2 && { mt: 17, mr: 8, ml: -4 }), // Tercer círculo un poco abajo y hacia la izquierda
              ...(index === 3 && { mt: -22, mr: 3, ml: -8.5 }), // Cuarto círculo un poco arriba
              ...(index === 4 && { mt: 6, mr: 1, ml: -1 }), // Quinto círculo abajo
            },
          }}>
            <Box
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              sx={{
                width: { xs: '150px', sm: '150px', lg: '260px' },
                maxWidth: { lg: '80%' },
                height: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                cursor: 'pointer',
                transition: 'transform 0.3s',
                '&:hover': { transform: 'scale(1.05)' },
              }}
            >
              <Box
                component="img"
                src={circle.image}
                alt={circle.label}
                sx={{
                  width: 'auto',
                  height: 'auto',
                  maxWidth: '100%',
                  maxHeight: '253px',
                }}
              />
            </Box>
            {/* Texto debajo solo en Mobile */}
            {isMobile && (
              <Fade in={hoveredIndex === index} timeout={500} unmountOnExit>
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                  <Typography
                    sx={{
                      fontSize: { xs: '20px', sm: '25px' },
                      fontWeight: '600',
                      mb: 1,
                      px: 2,
                      borderRadius: '50rem',
                      background: 'linear-gradient(0deg, rgb(10,98,116,0.1), rgba(19, 184, 218, 0.10))',
                      color: '#D4A76A',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backdropFilter: 'blur(10px)',
                      WebkitBackdropFilter: 'blur(10px)',
                      boxShadow: '0px 2px 10px rgba(0,0,0,0.5), -1px -2px 5px rgba(255,255,255,0.2)',
                      transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
                      zIndex: 1,
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        padding: '1px',
                        borderRadius: '50rem',
                        background: 'linear-gradient(0deg, rgb(10,98,116,0.8), rgba(19, 184, 218, 0.8))',
                        WebkitMask:
                          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                        WebkitMaskComposite: 'xor',
                        maskComposite: 'exclude',
                        zIndex: -1,
                        transition: 'opacity 0.3s ease',
                      },
                    }}
                  >
                    {circle.label}
                  </Typography>
                  <Typography sx={{
                    mt: 1,
                    maxWidth: '866px',
                    p: 4,
                    backdropFilter: "blur(12px)",
                    backgroundColor: "linear-gradient(to right,rgb(0, 0, 0.0.2),rgb(0, 0, 0,0.3))",
                    color: "white",
                    transition: "all 0.3s ease",
                    boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
                    textAlign: 'justify',
                    '&::before': {
                      borderRadius: "20px",
                      content: '""',
                      position: 'absolute',
                      inset: 0,
                      padding: '1px',
                      background: 'linear-gradient(90deg, #666666,rgba(0, 0, 0, 1))',
                      WebkitMask:
                        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                      WebkitMaskComposite: 'xor',
                      maskComposite: 'exclude',
                      zIndex: -1,
                      transition: 'opacity 0.3s ease',
                    },
                  }}>
                    {circle.description}
                  </Typography>
                </Box>
              </Fade>
            )}
          </Grid>
        ))}
      </Grid>

      {/* Texto global debajo en Desktop */}
      {!isMobile && (
        <Fade in={hoveredIndex !== null} timeout={500} unmountOnExit>
          <Box sx={{ mt: 6, maxWidth: '800px', textAlign: 'center' }}>
            <Typography
              sx={{
                fontSize: { xs: '20px', sm: '25px' },
                fontWeight: '600',
                mb: 1,
                px: 2,
                borderRadius: '50rem',
                background: 'linear-gradient(0deg, rgb(10,98,116,0.1), rgba(19, 184, 218, 0.10))',
                color: '#D4A76A',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                boxShadow: '0px 2px 10px rgba(0,0,0,0.5), -1px -2px 5px rgba(255,255,255,0.2)',
                transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
                zIndex: 1,
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  padding: '1px',
                  borderRadius: '50rem',
                  background: 'linear-gradient(0deg, rgb(10,98,116,0.8), rgba(19, 184, 218, 0.8))',
                  WebkitMask:
                    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  zIndex: -1,
                  transition: 'opacity 0.3s ease',
                },
              }}
            >
              {hoveredIndex !== null && circlesData[hoveredIndex].label}
            </Typography>
            <Typography sx={{
              mt: 1,
              maxWidth: '866px',
              p: 4,
              backdropFilter: "blur(12px)",
              backgroundColor: "linear-gradient(to right,rgb(0, 0, 0.0.2),rgb(0, 0, 0,0.3))",
              color: "white",
              transition: "all 0.3s ease",
              boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
              textAlign: 'justify',
              '&::before': {
                borderRadius: "20px",
                content: '""',
                position: 'absolute',
                inset: 0,
                padding: '1px',
                background: 'linear-gradient(90deg, #666666,rgba(0, 0, 0, 1))',
                WebkitMask:
                  'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                zIndex: -1,
                transition: 'opacity 0.3s ease',
              },
            }}>
              {hoveredIndex !== null && circlesData[hoveredIndex].description}
            </Typography>
          </Box>
        </Fade>
      )}
    </Box>
  );
}